<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label class="required ts-text-xs">{{ $t('gamePrefix.prefix') }}</label>
          <input v-model.trim="model.prefix" type="text" class="form-control" @input="joinString" />
          <div class="validate ts-text-xs" v-if="errors.has('prefix')">{{ errors.first('prefix') }}</div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label class="required ts-text-xs">{{ $t('gamePrefix.digit') }}</label>
          <input
            v-model.number="model.sequence_digit"
            type="number"
            class="form-control"
            @input="joinString"
          />
          <div
            class="validate ts-text-xs"
            v-if="errors.has('sequence_digit')"
          >{{ errors.first('sequence_digit') }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label class="required ts-text-xs">{{ $t('gamePrefix.year') }}</label>
          <select class="form-control" v-model="model.yyyy" @change="joinString">
            <option value="YYYY">YYYY</option>
            <option value="YY">YY</option>
          </select>
        </div>
      </div>
      <div class="col-md-6 ts-flex ts-items-end">
        <div class="form-group">
          <ts-checkbox
            v-model="model.mm"
            class="ts-text-xs ts-mb-2"
            @change="joinString"
          >{{ $t('gamePrefix.includeMonth')}}</ts-checkbox>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label class="ts-text-xs">{{$t('gamePrefix.sample')}}</label>
          <input v-model="model.prefix_sample" type="text" class="form-control" readonly />
          <div
            class="validate ts-text-xs"
            v-if="errors.has('prefix_sample')"
          >{{ errors.first('prefix_sample') }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 ts-flex ts-space-x-3 ts-justify-end">
        <ts-button @click.prevent="$emit('close')">{{ $t('cancel') }}</ts-button>
          <ts-button
            v-if="isEdit"
            color="primary"
            :waiting="updating"
            @click.prevent="onUpdate"
            >{{ $t('update') }}</ts-button
          >
          <div v-if="!isEdit">
            <ts-button
              class="mr-2"
              color="primary"
              outline
              :waiting="waiting_new"
              @click.prevent="onSaveNew"
              >{{ $t('save_add_new') }}</ts-button
            >
            <ts-button
              color="primary"
              :waiting="waiting"
              @click.prevent="onSave"
              >{{ $t('save') }}</ts-button
            >
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'formCreateOrUpdate',
  data() {
    return {
      waiting: false,
      waiting_new: false,
      updating: false,
			errors: new Errors(),
      model: {
        prefix_id: 0,
        yyyy: 'YYYY',
        sequence_digit: null,
        prefix: null,
        mm: false,
        prefix_sample: null
      }
    }
  },
  created() {
    this.setEditData()
  },
  computed: {
    ...mapState('administrator/gamePrefix', ['edit_data']),
    isEdit() {
      return !_.isEmpty(this.$store.state.administrator.gamePrefix.edit_data)
    }
  },
  methods: {
    ...mapActions('administrator/gamePrefix', ['store', 'update']),
    joinString() {
      if (this.model.mm) {
        this.model.prefix_sample = _.join(
          [this.model.prefix, this.model.yyyy, 'MM', this.sequent()],
          ''
        )
      } else {
        this.model.prefix_sample = _.join(
          [this.model.prefix, this.model.yyyy, this.sequent()],
          ''
        )
      }
    },
    sequent() {
      let create_sequent = []
      for (var i = 1; i <= this.model.sequence_digit; i++) {
        create_sequent.push(i == this.model.sequence_digit ? 1 : 0)
      }

      return _.join(create_sequent, '')
    },
    onSave() {
      this.waiting = true
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('close')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onSaveNew(){
      this.errors = new Errors()
      this.waiting_new = true
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting_new = false
        })
    },
    onUpdate(){
      this.errors = new Errors()
      this.updating = true
      this.update({
        id: this.model.prefix_id,
        data: this.model
      })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('close')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.updating = false
        })
    },
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.model.prefix_id = this.edit_data.prefix_id
        this.model.yyyy = this.edit_data.yyyy
        this.model.sequence_digit = this.edit_data.sequence_digit
        this.model.prefix = this.edit_data.prefix
        this.model.mm = this.edit_data.mm
        this.model.prefix_sample = this.edit_data.prefix_sample
      }
    },
    clearInput(){
      this.model.yyyy = 'YYYY'
      this.model.sequence_digit = null
      this.model.prefix = null
      this.model.mm = false
      this.model.prefix_sample = null
    }
  }
}
</script>